export const getCliniciansData = state => state.clinicians.all;
export const getClinicianData = state => state.clinicians.clinician;
export const cliniciansIsFetching = state => state.clinicians.loading.all;
export const clinicianIsFetching = state => state.clinicians.loading.clinician;